<div class="main-filters-cont">
  <ng-container *ngFor="let mainFilterItem of currentMainFilterItems">
    <ng-container
      *ngIf="!mainFilterItem.groups || (mainFilterItem.groups && mainFilterItem.groups.indexOf(selectedGroup) >= 0)">
      <div class="main-filter-item" [hidden]="mainFilterItem.hidden || mainFilterItem?.options?.length <= 0">
        <div class="main-filter-item-label d-none">{{mainFilterItem?.label}}:</div>
        <ng-container *ngIf="mainFilterItem?.type === 'toggle-filter'">
          <div aria-label="Basic example" class="btn-group toggle-filter insight-toggle-filter" role="group">
            <ng-container *ngFor="let option of mainFilterItem?.options">
              <button class="btn btn-secondary" (click)="selectMainFilter(mainFilterItem,option)"
                [ngClass]="{ active: mainFilterItem.selected.value === option.value }" type="button"
                [innerHTML]="option.label">
              </button>
            </ng-container>
          </div>
        </ng-container>
        <ng-container *ngIf="mainFilterItem?.type !== 'toggle-filter'">
          <button class="btn btn-secondary text-capitalize" [hidden]="mainFilterItem?.options?.length > 0"
            [innerHTML]="mainFilterItem?.selected?.label">
          </button>
          <div class="dropdown filter-dropdown" [hidden]="mainFilterItem?.options?.length <= 0">
            <button class="btn btn-secondary dropdown-toggle text-capitalize" type="button" id="dropdownMenuButton"
              data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
              [innerHTML]="mainFilterItem?.selected?.label" [ngClass]="{disabled: mainFilterItem?.options?.length < 2}"
              (click)="selectedMainFilterItemClick(mainFilterItem, $event)">
            </button>
            <div class="filter-dropdown-tooltip" *ngIf="mainFilterItem?.tooltip && mainFilterItem?.showTooltip">
              {{mainFilterItem?.tooltip}}
              <i class="fa fa-caret-down"></i>
            </div>
            <div class="dropdown-menu" aria-labelledby="dropdownMenuButton" #dropdownMenu>
              <ng-container *ngIf="mainFilterItem?.options?.length > 10">
                <div class="input-group">
                  <span class="input-group-addon" id="search-country">
                    <i class="fa fa-search"></i>
                  </span>
                  <input class="form-control" placeholder="Search..." type="text"
                    [attr.id]="'search-input-'+mainFilterItem.key" [(ngModel)]="mainFilterItem.searchText"
                    (keydown.enter)="onSearchEnter(mainFilterItem)" (ngModelChange)="onSearchChange(mainFilterItem)">
                </div>
              </ng-container>
              <div class="dropdown-menu-items">
                <ng-container *ngFor="let option of mainFilterItem?.options">
                  <ng-container *ngIf="!option?.hidden">
                    <a class="dropdown-item text-capitalize" (click)="selectMainFilter(mainFilterItem,option)"
                      [innerHTML]="option?.label">{{option?.label}}</a>
                  </ng-container>
                </ng-container>
                <ng-container *ngIf="mainFilterItem.showNoResults">
                  <div class="dropdown-item">No results found.</div>
                </ng-container>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
    </ng-container>
  </ng-container>
</div>